import { useState } from "react";
import { CallListGlobalModalContext } from "./call-list-global-modal-context";

type Props = {
  children: React.ReactNode;
};

export function WithCallListGlobalModal(props: Props) {
  const [consultantId, setConsultantId] = useState<string | null>(null);

  const open = (consultantId: string) => {
    setConsultantId(consultantId);
  };

  return (
    <CallListGlobalModalContext.Provider value={{ consultantId, open }}>
      {props.children}
    </CallListGlobalModalContext.Provider>
  );
}
